import styles from '../styles/main.module.css';

const TaskTracker = () => {
    return (
        <main className={`${styles.main} ${styles.mainJaasWorks}`}>
            {/* <div className={styles.projectImg}>

            </div> */}
            
            <div className={styles.projectDetails}>
                <div className={styles.projectTitle}>
                    <h3 className={styles.projectTitle}>
                        Task Tracker
                    </h3>
                </div>
                <div className={styles.projectDescription}>
                    <p className={styles.projectDescription}>
                        Helping organisations boost productivity and employee performance.
                    </p>
                </div>
                <div className={styles.projectsLink}>
                    <a href="/" className={styles.projectLink}>www.tasktracker.com</a>
                </div>
            </div>

            {/* <svg width="97" height="116" viewBox="0 0 97 116" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_11_275)">
            <path d="M47.2571 65.3118C47.8315 65.0128 48.5152 65.0104 49.0917 65.3055L79.0487 80.6372C80.5004 81.3802 80.5004 83.455 79.0487 84.198L49.0917 99.5297C48.5152 99.8247 47.8315 99.8224 47.2571 99.5234L17.8036 84.1916C16.3682 83.4445 16.3682 81.3907 17.8036 80.6435L47.2571 65.3118Z" fill="black" fill-opacity="0.01"/>
            </g>
            <path d="M10 27.7812C10 24.1927 11.9229 20.8792 15.0386 19.0988L43.5001 2.83508C46.5745 1.07832 50.3486 1.07832 53.4229 2.83508L81.8845 19.0988C85.0002 20.8792 86.9231 24.1927 86.9231 27.7812V60.1308C86.9231 63.7194 85.0002 67.0328 81.8845 68.8133L53.4229 85.077C50.3486 86.8338 46.5745 86.8338 43.5001 85.077L15.0386 68.8133C11.9229 67.0328 10 63.7194 10 60.1308V27.7812Z" fill="#FFE6E6"/>
            <path d="M13.6631 29.575C13.6631 26.0066 15.5646 22.7086 18.6527 20.9207L43.4513 6.56365C46.5505 4.76934 50.3727 4.76934 53.472 6.56365L78.2705 20.9207C81.3587 22.7086 83.2602 26.0066 83.2602 29.575V58.337C83.2602 61.9053 81.3587 65.2033 78.2705 66.9912L53.472 81.3483C50.3727 83.1426 46.5505 83.1426 43.4513 81.3483L18.6527 66.9912C15.5646 65.2033 13.6631 61.9053 13.6631 58.3369V29.575Z" fill="#FF8080"/>
            <path d="M48.4614 46.7827C48.4614 42.9346 50.6695 39.4278 54.1398 37.7648L78.4861 26.0974C80.6987 25.037 83.26 26.6498 83.26 29.1034V58.3371C83.26 61.9055 81.3585 65.2035 78.2703 66.9914L53.4649 81.3524C51.2427 82.639 48.4614 81.0355 48.4614 78.4677L48.4614 64.1027L48.4614 46.7827Z" fill="#FF5C5C"/>
            <defs>
            <filter id="filter0_d_11_275" x="0.727051" y="49.0859" width="95.4106" height="66.6635" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="8"/>
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.231373 0 0 0 0 0.231373 0 0 0 0.4 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11_275"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11_275" result="shape"/>
            </filter>
            </defs>
            </svg> */}

        </main>
    );
}
 
export default TaskTracker;